import { NamedProperty, CodedProperty } from "sprint-common-web";

import { GetSingleTvSeriesResponse } from "../../../../common/api/catalogue-api/tv-api/GetSingleTvSeriesResponse";

export interface TvSeriesCatalogueEntry {
    id: string;
    title: string;
    buzzId?: string;
    orphaned: boolean;
    seasons: TvSeasonCatalogueEntry[];
}

export interface TvSeasonCatalogueEntry {
    id: string;
    name: string;
    number: number;
    buzzId?: string;
    episodes: EpisodeCatalogueEntry[];
}

export interface EpisodeCatalogueEntry {
    id: string;
    title: string;
    number: number;
    buzzId?: string;
    versions: EpisodeVersionCatalogueEntry[];
}

export interface EpisodeVersionCatalogueEntry {
    id: string;
    buzzId?: string;
    type: NamedProperty;
    distributor: NamedProperty;
    brandings?: CodedProperty[];
}

export const mapToTvSeriesCatalogueEntry = (response: GetSingleTvSeriesResponse): TvSeriesCatalogueEntry => ({
    ...response
});
